import React, { useState } from 'react';
import { Button, Spinner, Table, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import dbService from '../../../services/dbService';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const PerpetualScreening = ({ watchlists }) => {
    const entityLists = watchlists.filter(wl => wl.type === 'Entity');
    const [isProcessing, setIsProcessing] = useState(false);
    const [results, setResults] = useState([]);
    const { user } = useAuth();
    const navigate = useNavigate();

    const runBatchScreening = async () => {
        setIsProcessing(true);
        setResults([]);
        const customers = await dbService.getAll('customers');
        let newHits = [];

        for (const customer of customers) {
            for (const list of entityLists) {
                for (const entry of list.entries) {
                    if (entry.name.toLowerCase() === customer.fullName.toLowerCase()) {
                        newHits.push({ customerName: customer.fullName, customerId: customer.id, listName: list.name });
                    }
                }
            }
        }

        setTimeout(() => { // Simulate processing time
            setResults(newHits);
            toast.success(`Batch screening complete. Found ${newHits.length} potential new matches.`);
            dbService.addLog({ user: user.name, action: 'Perpetual Screening Batch', details: `Ran batch job, found ${newHits.length} hits.` });
            setIsProcessing(false);
        }, 2000);
    };

    const createCase = async (hit) => {
        // This would have more logic to check if a case already exists
        const newCase = {
            customerName: hit.customerName, customerId: hit.customerId, risk: 'High',
            status: 'Open', assignedTo: 'Compliance', openDate: new Date().toISOString().split('T')[0],
            notes: [{ user: 'System', text: `Case created from Perpetual Screening batch hit on ${hit.listName}.`, timestamp: new Date().toISOString() }],
            auditTrail: [], transactions: []
        };
        const newCaseId = await dbService.add('cases', newCase);
        toast.success(`New Case #${newCaseId} created for ${hit.customerName}.`);
        navigate(`/case-management/${newCaseId}`);
    };

    return (
        <div>
            <p>Simulate a periodic (e.g., nightly) batch process that re-screens the entire customer database against the latest watchlist data. This catches existing customers who may have been recently added to a sanction list.</p>
            <div className="text-center mb-4">
                <Button onClick={runBatchScreening} disabled={isProcessing} size="lg">
                    {isProcessing ? <><Spinner as="span" size="sm" /> Processing...</> : 'Run Daily Batch Screening'}
                </Button>
            </div>
            {results.length > 0 && (
                <Alert variant="danger">
                    <Alert.Heading>New Matches Found!</Alert.Heading>
                    <p>The following existing customers were found on a watchlist and require immediate review.</p>
                    <Table striped bordered size="sm">
                        <thead><tr><th>Customer</th><th>Found On List</th><th>Action</th></tr></thead>
                        <tbody>
                            {results.map(hit => (
                                <tr key={hit.customerId}>
                                    <td>{hit.customerName} (<code>{hit.customerId}</code>)</td>
                                    <td>{hit.listName}</td>
                                    <td><Button size="sm" variant="danger" onClick={() => createCase(hit)}>Create Case</Button></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Alert>
            )}
        </div>
    );
};

export default PerpetualScreening;